import axios from 'axios';
import VueRouter from 'vue-router';
import userRouter from '@/router/userRouter';
import activityRouter from '@/router/activityRouter';
// import adminRouter from '@/router/adminRouter';
import albumRouter from '@/router/albumRouter';
import commonRouter from '@/router/commonRouter';
// import unauthenticatedRouter from '@/router/unauthenticated';
import store from '@/store';
// const authenticatedRouters = [
// 	{
// 		path: '/packages',
// 		component: () => import('@/App.vue'),
// 		name: 'authenticated.home',
// 		children: [...userRouter, ...activityRouter, ...albumRouter, ...commonRouter]
// 	}
// ];
// console.log([...unauthenticatedRouter, ...authenticatedRouters]);
const router = new VueRouter({
	// mode:history,
	routes: [...userRouter, ...activityRouter, ...albumRouter, ...commonRouter],
	axios,
	history: true,
	// base:'/admin/'
});

router.beforeEach((to, from, next) => {
	const { currentRoleIds, isAccount } = store.state.company;
	let unauthorized = false;
	for (let i = to.matched.length - 1; i >= 0; i--) {
		const code = to.matched[i].meta?.code;
		if (code) {
			if (currentRoleIds && currentRoleIds.length && !currentRoleIds.includes(code)) {
				unauthorized = true;
			}
			break;
		}
	}
	console.log(currentRoleIds);
	if (isAccount && unauthorized) {
		next({ name: 'user.selfcenter' });
	} else {
		next();
	}
});

// 解决重复点击导航时，控制台出现报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch((err) => err);
};
const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(to) {
	return VueRouterReplace.call(this, to).catch((err) => err);
};

router.onError((error) => {
	// 时间: 2021-12-14 出现了 ChunkLoadError:Loading chunk 22 failed. 添加错误捕获
	// 修复问题：在我的直播列表中，点击直播间控制台报错，没有反应 -- 问题只出现在开发环境，测试以及线上环境未发现此问题
	console.error(error);
	const pattern = /Loading chunk (\d)+ failed/g;
	const isChunkLoadFailed = error.message.match(pattern);
	const targetPath = router.history.pending.fullPath;
	if (isChunkLoadFailed) {
		router.replace(targetPath);
	}
});
router.afterEach(() => {
	// store.commit('updateLoadingStatus', { isLoading: false });
});

export default router;
